import { motion } from 'framer-motion'

export default function BlogUpvote({ count, hasUpvoted, onUpvote }) {
  return (
    <motion.button
      className={`upvote-btn ${hasUpvoted ? 'upvoted' : ''}`}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onUpvote()
      }}
      whileTap={{ scale: 0.95 }}
      whileHover={{ scale: 1.05 }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill={hasUpvoted ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
      <span>{count}</span>
    </motion.button>
  )
}
